<template>
	<div class="data_box">
		<div class="detail">
			<div class="detail_box" v-if="currentRecord">
				<div class="column">
					<div class="name">实时起重</div>
					<div class="text">{{ currentRecord.load / 10 || '0' }}KG</div>
				</div>
				<div class="column">
					<div class="name">实时人数</div>
					<div class="text">{{ currentRecord.peopleNumber || '0' }}人</div>
				</div>
				<div class="column">
					<div class="name">实时高度</div>
					<div class="text">{{ currentRecord.height / 10 || '0' }}m</div>
				</div>
				<div class="column">
					<div class="name">实时方向</div>
					<div class="text">{{ getDirection(currentRecord.direction) }}</div>
				</div>
				<div class="column">
					<div class="name">实时倾斜坡度X</div>
					<div class="text">{{ currentRecord.tiltX / 100 || '0' }}°</div>
				</div>
				<div class="column">
					<div class="name">实时倾斜坡度Y</div>
					<div class="text">{{ currentRecord.tiltY / 100 || '0' }}°</div>
				</div>
				<div class="column">
					<div class="name">状态</div>
					<div class="text">{{ currentRecord.status ? fnElevatorStatusToText(currentRecord.status) : '无' }}</div>
				</div>
			</div>
		</div>
		<div class="figure"></div>
		<div class="indicator">
			<div class="today">
				<div class="title">今日数据统计</div>
				<div class="con">
					<div class="con_box">
						<div class="box_title">预报警</div>
						<div class="box_count"><span>{{ warningCount }}</span>次</div>
						<div class="box_btn"><div class="search-btn orange" @click="fnOpenAlarmWin"><span>查看详情</span></div></div>
					</div>
					<div class="con_box">
						<div class="box_title">装载次数</div>
						<div class="box_count"><span>{{ cycleCount }}</span>次</div>
                        <div class="box_btn"><div class="search-btn orange" @click="fnOpenAlarmWin"><span>查看详情</span></div></div>
					</div>
				</div>
			</div>
			<div class="security">
				<div class="title">安全统计</div>
				<div class="con"><div class="safety-rate" id="safety-rate-chart" ref="safetyRate"></div></div>
			</div>
		</div>
		<div class="elevator_chart">
			<div id="elevator-chart" class="chart-container" ref="container"></div>
			<div class="open-dateils"><div @click="fnOpenRealTimeWin" class="search-btn orange"><span>查看详情</span></div></div>
		</div>
	</div>
</template>

<script>
import echarts from 'echarts';
require('echarts/theme/macarons'); // echarts theme
import request from '@/utils/request';
import APP from '@/utils/base';
export default {
	props: {
		currentElevator: {
			type: Object
		}
	},
	data() {
		return {
			timer: null,
			safetyRateChart: null,
			elevatorChart: null,
			currentRecord: {}, // 设备当前最新一条实时记录
			warningCount: 0, // 预报警条数统计
			cycleCount: 0, // 装载条数统计
			recordCount: 1, // 记录条数统计
			safetyRate: 100, // 安全统计
			chartDataX: [], // 统计图X轴数据
			loadY: [], // 统计图Y轴实时起重
			speedY: [], // 统计图Y轴实时速度
			heightY: [], // 统计图Y轴实时高度
			peopleNumberY: [], // 统计图Y轴实时人数
			targetHeight: 60,
			anchorLeft: 31,
			currentElevatorNew: {
				eqptStatus: '',
				number: '',
				nowTime: ''
			}
		};
	},
	created() {
		this.fnGetChartData();
		this.timer = setInterval(() => {
			this.fnGetChartData();
		}, 120000);
	},
	watch: {
		currentElevator: {
			immediate: true,
			deep: true,
			handler: function(newV, oldV) {
				if (oldV && newV) {
					if (newV.number !== oldV.number) {
						clearInterval(this.timer);
						this.timer = setInterval(() => {
							this.fnGetChartData();
							this.fnGetTodayRecord();
							this.fnGetLatestRecord();
						}, 120000);
					}
					if(newV.nowTime >= oldV.nowTime){
						this.fnGetChartData();
						this.fnGetTodayRecord();
						this.fnGetLatestRecord();
					}
				}
				if (newV === undefined) {
					this.currentElevatorNew = {
						eqptStatus: '',
						number: '',
						nowTime: ''
					}
				} else {
					this.currentElevatorNew.eqptStatus = newV.eqptStatus;
					this.currentElevatorNew.number = newV.number;
					this.currentElevatorNew.nowTime = newV.nowTime;
				}
				this.fnGetChartData();
				this.fnGetTodayRecord();
				this.fnGetLatestRecord();
			}
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
	methods: {
		chartResize() {
			this.elevatorChart.resize();
		},
		getDirection(_key) {
			switch (_key) {
				case 0:
					return '停止';
				case 1:
					return '向下';
				case 2:
					return '向上';
				default:
					return '无';
					break;
			}
		},
		// 查看预报警记录
		fnOpenAlarmWin() {
			this.$parent.fnOpenElevatorAlarm();
		},
		// 查看吊装记录
		fnOpenHoistingRecordWin() {
			this.$parent.fnOpenHoistingRecord();
		},
		// 查看运行记录
		fnOpenRealTimeWin() {
			this.$parent.fnOpenElevatorRealTimeRecord();
		},
		// 查看升降机运行记录
		fnOpenElevatorRecord() {
			this.$parent.fnOpenElevatorRealTimeRecord();
		},
		// 升降机运行状态
		fnElevatorStatusToText(_status) {
			if (_status) {
				return APP.fnCraneStatusToText(_status, 'elevator').msg;
			}
		},
		// 升降机统计图初始化
		fnElevatorChart() {
			this.elevatorChart = echarts.init(this.$refs.container);
			this.elevatorChart.setOption({
				backgroundColor: 'rgba(29,68,149,.1)',
				title: {
					top: 20,
					text: '运行记录',
					textStyle: {
						fontWeight: 'normal',
						fontSize: 16,
						color: '#F1F1F3'
					},
					left: '1%'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						lineStyle: {
							color: '#57617B'
						}
					}
				},
				legend: {
					top: '20px',
					textStyle: {
						color: '#fff'
					},
					data: ['实时载重', '实时速度', '实时高度', '实时人数']
				},
				grid: {
					top: 100,
					left: '2%',
					right: '2%',
					bottom: '2%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						},
						data: this.chartDataX
					}
				],
				yAxis: [
					{
						type: 'value',
						name: '',
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#fff'
							}
						},
						axisLabel: {
							margin: 10,
							textStyle: {
								fontSize: 14
							}
						},
						splitLine: {
							lineStyle: {
								color: '#57617B'
							}
						}
					}
				],
				series: [
					{
						name: '实时载重',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: 'rgb(137,189,27)',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.loadY
					},
					{
						name: '实时速度',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#909399',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.speedY
					},
					{
						name: '实时高度',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#F56C6C',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.heightY
					},
					{
						name: '实时人数',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 5,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 2
							}
						},
						itemStyle: {
							normal: {
								color: '#409EFF',
								borderColor: 'rgba(137,189,2,0.27)',
								borderWidth: 12
							}
						},
						data: this.peopleNumberY
					}
				]
			});
		},
		// 安全运行率统计
		fnSafetyRateChart() {
			this.safetyRateChart = echarts.init(this.$refs.safetyRate);
			this.safetyRateChart.setOption({
				title: {
					text: '安全运行率',
					left: '20px',
					textStyle: {
						color: '#fff'
					}
				},
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				legend: {
					orient: 'vertical',
					x: 'left',
					show: false,
					data: ['异常占比', '正常占比']
				},
				series: [
					{
						name: '安全统计',
						type: 'pie',
						radius: ['50%', '70%'],
						avoidLabelOverlap: false,
						label: {
							normal: {
								position: 'center'
							},
							emphasis: {
								show: true,
								textStyle: {
									fontSize: '16',
									fontWeight: 'bold'
								}
							}
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						data: [
							{ value: this.recordCount - this.warningCount, itemStyle: { color: '#ECC64D' }, name: '正常占比' },
							{ value: this.warningCount, label: { show: false }, name: '异常占比' }
						]
					}
				]
			});
		},
		// 获取升降机实时数据记录公共方法
		fnGetElevatorRecord(_obj, _cb) {
			request({
				notLoading: true,
				url: 'elevator/getRecord',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					_cb && _cb(res.data);
				})
				.catch(err => {
					this.currentRecord = {};
				});
		},
		// 获取最新一条升降机实时记录
		fnGetLatestRecord() {
			if (!(this.currentElevatorNew && this.currentElevatorNew.number)) return;
			this.fnGetElevatorRecord(
				{
					number: this.currentElevatorNew.number,
					page: 1,
					size: 1
				},
				res => {
					this.currentRecord = res.query[0];
					this.$nextTick(() => {
						this.fnSafetyRateChart();
					});
				}
			);
		},
		// 获取升降机当天实时记录
		fnGetTodayRecord() {
			let _that = this;
			if (!(_that.currentElevatorNew && _that.currentElevatorNew.number)) {
				_that.recordCount = 1;
				return;
			}
			let _myDate = new Date().Format('yyyy-MM-dd');
			let _startTime = _myDate + ' 00:00:00';
			let _endTime = _myDate + ' 23:59:59';
			let _createAt = _startTime + ',' + _endTime;
			let _recordArr = [];
			let _cycleArr = [];
			let _recordPage = 1;
			let _cyclePage = 1;
			let _size = 50;
			let _warning = 0; // 预报警信息统计
			let _cycle = 0; // 装载次数统计
			_fnGetCycle(() => {
				_fnGetRecord(() => {
					request({
						url: 'elevator/getRecord',
						method: 'GET',
						params: {
							number: _that.currentElevatorNew.number,
							page: 1,
							size: 1,
							create_at: _createAt,
							is_alarm: 1
						}
					})
						.then(res => {
							_that.warningCount = res.data.count;
							_that.fnSafetyRateChart();
						})
						.catch(err => {});
				});
			});

			// 获取装载记录、实时记录总条数
			function _fnGetCycle(_cb) {
				request({
					url: 'elevator/getCycle',
					method: 'GET',
					params: {
						number: _that.currentElevatorNew.number,
						page: 1,
						size: 1,
						create_at: _createAt
					}
				})
					.then(res => {
						_that.cycleCount = res.data.count;
						_cb && _cb();
					})
					.catch(err => {
						_cb && _cb();
					});
			}

			// 获取实时记录总条数
			function _fnGetRecord(_cb) {
				request({
					url: 'elevator/getRecord',
					method: 'GET',
					params: {
						number: _that.currentElevatorNew.number,
						page: 1,
						size: 1,
						create_at: _createAt
					}
				})
					.then(result => {
						_that.recordCount = result.data.count ? result.data.count : 1;
						_cb && _cb();
					})
					.catch(err => {
						_that.recordCount = 1;
						_cb && _cb();
					});
			}
		},
		// 获取升降机统计图数据
		fnGetChartData() {
			if (!this.currentElevatorNew.number) {
				let _myDate = new Date().getTime();
				let _index = 0;
				let _chartDataX = [];
				let _loadY = [];
				let _speedY = [];
				let _heightY = [];
				let _peopleNumberY = [];
				while (_index < 20) {
					_myDate -= 1000 * 10;
					_chartDataX.unshift(new Date(_myDate).Format('hh:mm:ss'));
					_loadY.unshift(0);
					_speedY.unshift(0);
					_heightY.unshift(0);
					_peopleNumberY.unshift(0);
					_index++;
				}
				this.chartDataX = _chartDataX;
				this.loadY = _loadY;
				this.speedY = _speedY;
				this.heightY = _heightY;
				this.peopleNumberY = _peopleNumberY;
				this.$nextTick(() => {
					this.fnElevatorChart();
				});
				return;
			}
			request({
				notLoading: true,
				url: 'elevator/getRecord',
				method: 'GET',
				params: {
					number: this.currentElevatorNew.number,
					page: 1,
					size: 20
				}
			})
				.then(res => {
					this.currentRecord = res.data.query[0];
					let _data = res.data.query;
					let _chartDataX = [];
					let _loadY = []; //实时起重
					let _speedY = []; //实时速度
					let _heightY = []; //实时高度
					let _peopleNumberY = []; //实时人数
					_data.forEach(_item => {
						_chartDataX.unshift(_item.record_at.split(' ')[1]);
						_loadY.unshift(_item.load / 10);
						_speedY.unshift(_item.speed);
						_heightY.unshift(_item.height / 10);
						_peopleNumberY.unshift(_item.peopleNumber);
					});
					this.chartDataX = _chartDataX;
					this.loadY = _loadY;
					this.speedY = _speedY;
					this.heightY = _heightY;
					this.peopleNumberY = _peopleNumberY;
					this.$nextTick(() => {
						this.fnElevatorChart();
					});
				})
				.catch(err => {
					let _myDate = new Date().getTime();
					let _index = 0;
					let _chartDataX = [];
					let _loadY = [];
					let _speedY = [];
					let _heightY = [];
					let _peopleNumberY = [];
					while (_index < 20) {
						_myDate -= 1000 * 10;
						_chartDataX.unshift(new Date(_myDate).Format('hh:mm:ss'));
						_loadY.unshift(0);
						_speedY.unshift(0);
						_heightY.unshift(0);
						_peopleNumberY.unshift(0);
						_index++;
					}
					this.chartDataX = _chartDataX;
					this.loadY = _loadY;
					this.speedY = _speedY;
					this.heightY = _heightY;
					this.peopleNumberY = _peopleNumberY;
					this.$nextTick(() => {
						this.fnElevatorChart();
					});
				});
		}
	},
	mounted() {
		//resize echarts
		window.addEventListener('resize', this.chartResize);
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';

.data_box{
	width: 1600px;
	height: 778px;
	position: relative;
}
.detail {
	position: absolute;
	left: 40px;
	top: 0;
	.detail_box {
		width: 280px;
		background: rgba(29, 68, 149, 0.1);
		border-radius: 5px;
		box-shadow: 3px 3px 5px #042233;
		padding: 2px 10px;
		line-height: 40px;
		font-size: 18px;
		.column {
			@include flex-box();
			.name {
				@include flex-item();
				color: #42b89d;
			}
			.text {
				color: #fff;
			}
		}
	}
}
.figure{
	position: absolute;
	left: 360px;
	width: 880px;
	height: 420px;
	background: url('../../../../assets/images/icon-elevator-body.png') no-repeat 380px center;
	background-size: 120px 400px;
}
.indicator{
	position: absolute;
	left: 1280px;
	width: 320px;
	height: 500px;
	@include flex-box(center,center,column);
	.today,.security{
		width: 320px;
		height: 240px;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		margin-bottom: 10px;
		@include flex-box(center,center,column);
		.title{
			width: 320px;
			height: 50px;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			font-size: 24px;
			color: #fefefe;
			background: url(../../../../assets/img/per_list_bg.png) no-repeat;
			background-size: 100% 100%;
			@include flex-box(center,center);
		}
		.con{
			width: 320px;
			height: 190px;
			background-color: rgba(29, 68, 149, 0.1);
			position: relative;
			@include flex-box(space-around,center);
			.con_box{
				width: 160px;
				height: 190px;
				font-size: 16px;
				@include flex-box(center,center,column);
				&:nth-child(1){
					border-right: 1px dashed #1d4495;
				}
				.box_title{
					width: 160px;
					height: 70px;
					font-size: 22px;
					@include flex-box(center,center);
				}
				.box_count{
					width: 160px;
					height: 70px;
					@include flex-box(center,center);
					span{
						color: #E03E2D;
						font-size: 32px;
						margin: 0 5px;
					}
				}
				.box_btn{
					width: 160px;
					height: 50px;
					@include flex-box(center,center);
				}
			}
			.safety-rate {
				position: absolute;
				width: 320px;
				height: 170px;
				@include flex-box(center,center);
			}
		}
	}
}
.elevator_chart{
	width: 1600px;
	height: 278px;
	position: absolute;
	top: 500px;
	left: 0;
	.open-dateils {
		position: absolute;
		right: 30px;
		top: 20px;
	}
	.chart-container {
		position: relative;
		height: 260px;
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Elevator/elevatorDefault/components/Data.vue